import UI from "./base/UI";

/**
 * dropdown
 */

/**
#### HTML 구조 및 Data 속성 참고 페이지 - 해당페이지  select / menu 메뉴 
** [http://172.20.160.28:9700/kbank_html_mmk/components/kds_select.html](http://172.20.160.28:9700/kbank_html_mmk/components/kds_select.html)
*/
class DropdownSelect extends UI {
    defaults = {
    };

    constructor(el, options) {
        super('dropdown', el);

        this.init(el, options);
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...this.parseOptions(options)};
        this.button = this.$el.find('.ui-dropdown-btn');
        this.selectMenu = this.$el.find('.ui-dropdown-menu');
        this.activeIndex = this.button.attr('select-index') == undefined ? 0 : this.button.attr('select-index');
        this.render();
    }

    update() {
        this.detachEvents();
        this.attachEvents();
    }

    render() {
        this.update();
    }
    /**
     * open 이벤트 
     * @param {Number} index  
     * @example 
     * $('.ui-dropdown').data('ui').open(index));
     */
    open(index) {
        this.activeIndex = this.button.attr('select-index') == undefined ? 0 : this.button.attr('select-index');
        this.activeIndex = index != undefined ? index : this.activeIndex;
        this.defaults.position != undefined ? this.selectMenu.addClass(this.defaults.position) : '';
        this.selectMenu.show();
        this.selectMenu.find('.select-title')?.text(this.button.attr('title'));
        this.button.attr('aria-expaned', true).addClass('open');

        this.set('open');
        this.detachEvents();
        this.attachEvents();
    }
    /**
     * close 이벤트 
     * @param {Object} opt   (optionBtn : 드롭다운내 btn-option의 선택자)
     * @example 
     * $('.ui-dropdown').data('ui').close();
     * $('.ui-dropdown').data('ui').close({optionBtn: $(this)});
     */

    close(opt) {
        if (!!opt) {
            if (!!opt.optionBtn) {
                this.activeIndex = opt.optionBtn.attr('data-val');
            }
        }
        this.set('close')
        this.button?.attr({
            'aria-expaned': false,
            'select-index' : this.activeIndex
        }).removeClass('open');
        this.button?.find('.txt-name')?.text(this.button.text())
        this.selectMenu.hide();
        this.callbackFn && $.isFunction(this.callbackFn) && this.callbackFn();

        //CHPFMTASK-2472 : ui-dropdown-menu 영역이 접히지 않고 재오픈되는 현상 수정 (2025.06.19)
        const uiDropdownBtn = $('.ui-dropdown-btn');
        setTimeout(()=>{
            uiDropdownBtn?.css('pointer-events','auto');
        },600)
        $('.ui-kbank-page-control.activeSlide .page-inner-scroll').on('scroll',  function(){
            console.log('close scrolling');
            uiDropdownBtn?.css('pointer-events','auto');
        })
    }

    /**
     * 초기화 이벤트 
     * @example 
     * $('.ui-dropdown').data('ui').set();
     */
    set (type) {
        
        if (type == undefined) {
            this.activeIndex = 0;
        }
        this.button.find('.txt-name')?.text(this.selectMenu.find('.select-list li').eq(this.activeIndex).find('button').text())
        this.button.attr('select-index',this.activeIndex )
        for (var i = 0; i < this.selectMenu.find('.select-list li').length; i++) {
            this.selectMenu.find('.select-list li').eq(i).find('button').attr({
                'data-val': i,
                'aria-checked' : false
            }).removeClass('selected')

            if (i == this.activeIndex) {
                this.selectMenu.find('.select-list li').eq(i).find('button').attr('aria-checked', true).addClass('selected').focus();
                if (type == 'open' ) {
                    this.selectMenu.find('.select-list li').eq(i).find('button').focus();
                } else if (type == 'close') {
                    this.button.focus();
                }
            }
        }
    }
    attachEvents() {
        // 개발팀에서 click이벤트 적용 (2025.06.05) => 2025.06.09 롤백함
        $(document).off('touchstart.selectDrop').on('touchstart.selectDrop', '.select-dimmed', function(e){
            const uiDropdownBtn = $('.ui-dropdown-btn'); //CHPFMTASK-2472 : ui-dropdown-menu 영역이 접히지 않고 재오픈되는 현상 수정 (2025.06.19)
            uiDropdownBtn?.css('pointer-events','none'); //CHPFMTASK-2472 : ui-dropdown-menu 영역이 접히지 않고 재오픈되는 현상 수정 (2025.06.19)

            $('.ui-dropdown').each(function(idx,el){
                $(el).data('ui').close();
            })
        })
    }

    detachEvents() {
        this.$el.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }

    /**
     * 콜백 함수
     * @param {Function} fn 콜백 함수
     * @example
     * $('ui-dropdown').data('ui').callback(function(index){
     *      console.log('index', index);
     *  });
     */
    callback(fn) {
        this.callbackFn = fn;
    }

    /**
     * @example
     * 
     * $('ui-dropdown').data('ui').selectedIndex;   // 해당 드롭다운셀렉트 activeIndex값
     * */
    get selectedIndex() {
        return Number(this.activeIndex);
    }
}

export default DropdownSelect;
